import { BreadcrumbItem } from "../types/schema.types";
import type { BreadcrumbList } from "schema-dts";

/**
 * Builds Schema.org BreadcrumbList structured data
 * @param breadcrumbItems - Array of breadcrumb items with name and optional url
 * @returns Schema.org BreadcrumbList object (without @context — injector handles that)
 */
export function buildBreadcrumbSchema(
  breadcrumbItems: BreadcrumbItem[]
): BreadcrumbList {
  const breadcrumbList: BreadcrumbList = {
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbItems.map((item, index) => {
      const breadcrumbItem: any = {
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
      };

      // Only add URL if it exists (last item typically doesn't have URL)
      if (item.url) {
        breadcrumbItem.item = item.url;
      }

      return breadcrumbItem;
    }),
  };

  return breadcrumbList;
}
